import React, { useRef, useState } from "react";
import {
  Form,
  InputContainer,
  ButtonsContainer,
  FileUpload,
  Button,
  ErrorSpan,
} from "./DepositElements";
import { useTranslation } from "react-i18next";
import { selectCurrency } from "../../features/user/userSlice";
import { useSelector } from "react-redux";
import { formatNumber, toLocaleString } from "../../utils/tools";
import { selectLimites } from "../../features/limitaciones/limitacionesSlice";

const FormDeposit = ({
  form,
  handleChange,
  handleClose,
  handleSubmit,
  loading,
  image,
  setImage,
  tipo,
  bancos,
  zelle,
}) => {
  const [t] = useTranslation("global");
  const moneda = useSelector(selectCurrency);
  const fileInputRef = useRef();
  const [monto, setMonto] = useState(0);
  const limitaciones = useSelector(selectLimites);
  const [blur, setBlur] = useState(false);

  const handleMonto = (e) => {
    setBlur(true);
    handleChange(formatNumber(e));
    setMonto(parseFloat(e.target.value.replaceAll(".", "").replace(",", ".")));
    if (e.target.value === "") setMonto(0);
  };

  return (
    <Form enctype="multipart/form-data">
      <InputContainer>
        <label>{t("deposit.lbl-payment")}</label>
        <select value={form.tipoPago} onChange={handleChange} name="tipoPago">
          <option disabled value="">
            {t("deposit.input-payment")}
          </option>
          {tipo.map((item, i) => (
            <option key={item.tipo + i} value={item.tipo}>
              {item.tipo}
            </option>
          ))}
        </select>
      </InputContainer>
      <InputContainer>
        <label>{t("deposit.lbl-bank")}</label>
        <select
          value={form.nombreBanco}
          onChange={handleChange}
          name="nombreBanco"
        >
          <option disabled value="">
            {t("deposit.input-bank")}
          </option>
          {bancos.map((item, i) => (
            <option
              key={item.nombre + i}
              value={`${item.nombre}(${item.cuenta})`}
            >
              {item.nombre}({item.cuenta})
            </option>
          ))}
        </select>
      </InputContainer>
      <InputContainer>
        <label>{t("deposit.lbl-num")}</label>
        <input
          type="text"
          placeholder={t("deposit.lbl-num")}
          name="referencia"
          maxLength={50}
          value={form.referencia}
          disabled={form.referencia === "NO APLICA"}
          onChange={handleChange}
        />
      </InputContainer>
      {(moneda === "ARS" || zelle) && (
        <InputContainer>
          <label>NOMBRE DEL TITULAR QUIEN ENVIA:</label>
          <input
            type="text"
            placeholder="NOMBRE TITULAR"
            name="nombreTitular"
            value={form.nombreTitular}
            onChange={handleChange}
          />
        </InputContainer>
      )}
      <InputContainer>
        <label>{t("deposit.lbl-amount")}</label>
        <input
          type="text"
          placeholder="0,00"
          name="monto1"
          value={form.monto1}
          onChange={(e) => handleMonto(e)}
        />

        {limitaciones.minimo_deposito > 0 && monto < limitaciones.minimo_deposito && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} {toLocaleString(limitaciones.minimo_deposito)}{" "}
            {moneda}{" "}
          </ErrorSpan>
        )}
        {limitaciones.maximo_deposito > 0 &&
          monto > limitaciones.maximo_deposito &&
          blur && (
            <ErrorSpan>
              {t("deposit.amount-less-than")} {toLocaleString(limitaciones.maximo_deposito)}{" "}
              {moneda}{" "}
            </ErrorSpan>
          )}
      </InputContainer>

      <InputContainer>
        <label>
          {t("deposit.lbl-img")} <span>*{t("deposit.lbl-mandatory")}</span>
        </label>
        <FileUpload
          onClick={() => {
            fileInputRef.current.click();
          }}
        >
          <div className="file-upload-select">
            <div className="file-select-name">
              {image ? image.name : t("deposit.lbl-select-img")}
            </div>
            <div className="file-select-button">{t("deposit.lbl-btn-img")}</div>
            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              onChange={(e) => {
                const file = e.target.files[0];
                if (file && file.type.substring(0, 5) === "image") {
                  setImage(file);
                } else {
                  setImage(null);
                }
              }}
            />
          </div>
        </FileUpload>
      </InputContainer>

      <ButtonsContainer>
        <Button
          onClick={(e) => {
            e.preventDefault();
            handleClose();
          }}
        >
          {t("deposit.btn-cancel")}
        </Button>
        <Button
          primary={true}
          disabled={
            loading ||
            (limitaciones.minimo_deposito > 0
              ? monto < limitaciones.minimo_deposito
              : false) ||
            (limitaciones.maximo_deposito > 0
              ? monto > limitaciones.maximo_deposito
              : false)
          }
          onClick={handleSubmit}
        >
          {loading ? "CARGANDO..." : t("deposit.btn-confirm")}
        </Button>
      </ButtonsContainer>
    </Form>
  );
};

export default FormDeposit;
